const platformLanguage = {
  // This section is commented out because, in the EU region or Germany, the 'de' translation was being displayed. If we need to support it in the future, we can uncomment this.
  // languageArray: ['en', 'de']
  languageArray: ['en']
};
export default platformLanguage;
